import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import store from './store'
import { Button } from 'hljd'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      location: {
        query: { title, id, status, price }
      }
    } = this.props
    store.title = title
    store.id = id
    store.status = status
    store.price = price
  }

  render() {
    const { title, price, pay } = store
    return (
      <HeaderView title="收银台">
        <div className={styles.box}>
          <div className={styles.item}>
            <span className={styles.label}>订单名称：</span>
            {title}
          </div>
          <div className={styles.item}>
            <span className={styles.label} style={{ verticalAlign: 76 }}>
              支付方式：
            </span>
            <div className={styles.select} onClick={store.changePay('1')}>
              {pay == '1' && (
                <img src="https://qnm.hunliji.com/o_1chn1mblh10121cubmnh0u1mp4h.png" />
              )}

              <div
                className={
                  pay == '1'
                    ? `${styles.inner} ${styles.on}`
                    : `${styles.inner}`
                }
              >
                <span className={`${styles.icon} ${styles.icon1}`} />
                <div className={styles.text}>
                  <p>银行汇款至</p>
                  <p>婚礼纪账户</p>
                </div>
              </div>
              <p className={styles.tips}>
                <span>推荐</span>&nbsp;&nbsp;大额账单一次付清
              </p>
            </div>
            <div className={styles.select} onClick={store.changePay('2')}>
              {pay == '2' && (
                <img src="https://qnm.hunliji.com/o_1chn1mblh10121cubmnh0u1mp4h.png" />
              )}

              <div
                className={
                  pay == '2'
                    ? `${styles.inner} ${styles.on}`
                    : `${styles.inner}`
                }
              >
                <span className={`${styles.icon} ${styles.icon2}`} />
                <div className={styles.text} style={{ marginTop: 24 }}>
                  <p>在线支付</p>
                </div>
              </div>
              <p className={styles.tips}>实时到账 省心无纠纷</p>
            </div>
          </div>
          <div className={styles.item}>
            <span className={styles.label}>支付金额：</span>
            <span
              style={{ color: '#ff801a', fontWeight: 'bold', fontSize: 20 }}
            >
              {price}
            </span>&nbsp;元
          </div>

          <Button
            type="primary"
            style={{ marginLeft: 78 }}
            onClick={store.toPay}
          >
            确认支付
          </Button>
        </div>
      </HeaderView>
    )
  }
}
